import { gql } from "@apollo/client";
import StripePlanFields from "~/lib/queries/fragments/StripePlanFields";

export default gql`
  query StripePlans {
    stripePlans {
      ...StripePlanFields
    }
  }

  ${StripePlanFields}
`;
